import { Divider } from '@cko/primitives';
import styled from 'styled-components';

export const StyledColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-seed);
`;

export const StyledGridContainer = styled.div<{ col?: number }>`
  display: grid;
  ${({ col }) => `grid-template-columns: repeat(${col ?? 3}, 1fr);`}
  gap: var(--layout-spoon);
  height: 400px;
  overflow-y: scroll;
  padding: var(--layout-stamp);
`;

export const StyledGridRowDivider = styled(Divider)<{ col?: number }>`
  ${({ col }) => `grid-column: 1 / ${col ? col + 1 : 4};`}
`;
